import * as React from "react";
import Box from "@mui/material/Box";
import CommentIcon from '@mui/icons-material/Comment';
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridToolbarDensitySelector,
  useGridApiContext,
  gridExpandedSortedRowIdsSelector,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import IconButton from '@mui/material/IconButton';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { Modal, TextField, Button, List, ListItem, ListItemText, ListItemSecondaryAction } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";


import {
  Tooltip,
} from "@mui/material";

import { ToastContainer, toast } from 'react-toastify';
import { Stack, Avatar, Typography } from "@mui/material";

// import { useNavigate, } from "react-router-dom";
import getAccess from "../../../../utils/getAccess";

function CustomToolbar({ rows, columns, ...gridProps }) {
  const apiRef = useGridApiContext();
  const exportAllRows = async () => {
    const visibleRows = gridExpandedSortedRowIdsSelector(apiRef);
    const filteredRows = rows.filter((row) => visibleRows.includes(row.id));
    const columnIds = columns.filter((column) => column.field != 'actions').map((column) => column.field);
    const csvHeader = columnIds.join(', ');
    const csvContent = filteredRows
      .map((row, index) => {
        const rowValues = columnIds.map((columnId) => {
          if (columnId === 'user') {
            return `${row?.user?.name}`;
          }
          if (columnId === 'batch') {
            return `${row?.batch?.batchName}`;
          }
          return row[columnId]?.toString()?.replaceAll(",", " ");
        });
        return rowValues.join(', ');
      })
      .join('\n');
    const fullCsvContent = `${csvHeader}\n${csvContent}`;
    const blob = new Blob([fullCsvContent], { type: `text/csv;charset=utf-8` });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'BatchDoubts.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />

      <GridToolbarDensitySelector />
      <Tooltip title="Export All">
        <IconButton onClick={exportAllRows}>
          <SaveAltIcon style={{ color: 'red' }} />
        </IconButton>
      </Tooltip>
      {/* <GridToolbarQuickFilter /> */}
    </GridToolbarContainer>
  );
};

const AllBatchDoubt = () => {
  // const navigate = useNavigate();
  const access = getAccess();
  const [rows, setRows] = React.useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [currentImage, setCurrentImage] = React.useState("");
  // Comment modal state
  const [commentModalOpen, setCommentModalOpen] = React.useState(false);
  const [commentDoubtId, setCommentDoubtId] = React.useState(null);
  const [newComment, setNewComment] = React.useState("");
  // For demo, static messages
  const [comments, setComments] = React.useState([
    { id: 1, sender: 'Admin', message: 'Please clarify your doubt.', isSender: true },
    { id: 2, sender: 'Student', message: 'I need help with this topic.', isSender: false },
  ]);
  const [doubtComments, setDoubtComments] = React.useState([]);


  const handleOpenCommentModal = (doubtId) => {
    setCommentDoubtId(doubtId);
    getDoubtComments(doubtId);
    setCommentModalOpen(true);
  };
  const handleCloseCommentModal = () => {
    setCommentModalOpen(false);
    setCommentDoubtId(null);
    setNewComment("");
  };
  const handleSendComment = (commentDoubtId) => {
    if (!newComment.trim()) return;
    createBatchDoubtComment(commentDoubtId, newComment).then(() => {
      setNewComment("");
      getDoubtComments(commentDoubtId);
    }).catch(error => {
      toast.error("Failed to send comment: " + error.message);
    });
  };
  const createBatchDoubtComment = async (batchDoubtId, msg) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminSection/createBatchDoubtComment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ batchDoubtId, msg: msg + " (Resolved by :" + localStorage.getItem('details') + ")" })
    });
    const responseJson = await response.json();
    return responseJson;
  };
  // const handleDeleteComment = (id) => {
  //   setComments((prev) => prev.filter((c) => c.id !== id));
  //   setDoubtComments((prev) => prev.filter((c) => c.id !== id));
  // };

  const handleOpen = (image) => {
    setCurrentImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentImage("");
  };

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [rowCount, setRowCount] = React.useState(0);
  const [searchText, setSearchText] = React.useState("");
  const [inputText, setInputText] = React.useState("");
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [pendingFilter, setPendingFilter] = React.useState("");

  React.useEffect(() => {
    const handler = (e) => {
      const inFilterPanel =
        document.activeElement?.closest(".MuiDataGrid-filterForm");

      if (e.key === "Enter" && inFilterPanel) {
        setSearchText(pendingFilter);
        setPaginationModel((p) => ({ ...p, page: 0 }));
      }
    };

    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [pendingFilter]);

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchDoubts = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `${process.env.REACT_APP_LIVE_URL}/adminSection/getAllBatchDoubts?page=${paginationModel.page}&pageSize=${paginationModel.pageSize}&searchText=${searchText}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await res.json();
        setRows(json.data || []);
        setRowCount(json.count ?? 0);
      } catch {
        toast.error("Failed to load doubts");
      } finally {
        setLoading(false);
      }
    };
    fetchDoubts();
  }, [paginationModel.page, paginationModel.pageSize, searchText]);


  const deleteDoubt = async (id) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminSection/deleteBatchDoubt?doubtId=${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },

    });
    const responseJson = await response.json();
    if (responseJson?.status) {
      toast.success(responseJson.msg)
      setTimeout(() => window.location.reload()
        , 1000)
    } else {
      toast.error(responseJson.msg);
    }


  }

  const getDoubtComments = async (batchDoubtId) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminSection/getDoubtComments?batchDoubtId=${batchDoubtId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`

      }
    });
    const responseJson = await response.json();
    setDoubtComments(responseJson.data ?? []);
  };


  // const handleDoubtSelect = (doubtId) => {
  //   getDoubtComments(doubtId);
  // };
  console.log("doubtComments", doubtComments)
  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleActiveAndInActiveDoubtComment = (id, doubtId) => {
    makeActiveAndInActiveDoubtComment(id).then(() => {
      getDoubtComments(doubtId); // Fetch updated comments after status change
    });
  }

  const makeActiveAndInActiveDoubtComment = async (id) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminSection/makeActiveAndInActiveDoubtComment/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },

    });
    const responseJson = await response.json();
    if (responseJson?.status) {
      toast.success(responseJson.msg)
      // setTimeout(() => window.location.reload()
      // , 1000)
    } else {
      toast.error(responseJson.msg);
    }
  }

  const handleCommentDelete = (id, doubtId) => {
    deleteComment(id).then(() => {
      getDoubtComments(doubtId); // Fetch updated comments after status change
    });
  };

  const deleteComment = async (id) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminSection/deleteDoubtComment?commentId=${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },

    });
    const responseJson = await response.json();
    if (responseJson?.status) {
      toast.success(responseJson.msg)
      // setTimeout(() => window.location.reload()
      // , 1000)
    } else {
      toast.error(responseJson.msg);
    }
  }

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };


  const makeActiveAndInActive = async (id) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminSection/makeActiveAndInActiveDoubt/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
    });

    const responseJson = await response.json();
    if (responseJson?.status) {
      toast.success(responseJson.msg);

      // Update the row locally
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, isActive: !row.isActive } : row
        )
      );
    } else {
      toast.error(responseJson.msg);
    }
  };


  const makeSolvedAndUnSolvedDoubt = async (id) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminSection/makeSolvedAndUnSolvedDoubt/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
    });

    const responseJson = await response.json();
    if (responseJson?.status) {
      toast.success(responseJson.msg);

      // Update the row locally
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, isResolved: !row.isResolved } : row
        )
      );
    } else {
      toast.error(responseJson.msg);
    }
  };


  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true }
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };
  const rowsWithSerialNumber = rows?.map((row, index) => ({ ...row, serialNumber: index + 1 }));

  // console.log((access?.deleteAccess == true  || access?.access.includes('all') ))
  const columns = [
    {
      field: 'sno',
      headerName: 'S NO',
      width: 75,
      align: 'left',
      headerAlign: 'left',
      editable: false,
      renderCell: (params) => (
        <strong>{params.value}</strong>
      ),
    },
    {
      field: "batch",
      headerName: "Batch",
      type: "object",
      width: 200,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography variant="subtitle2" noWrap>{`${params?.value?.batchName}(${params?.value?.batchId})`}</Typography>
        </Stack>
      ),
      getApplyQuickFilterFn: (value) => {
        return (params) => {
          return (params?.value?.batchName?.includes(value) || params?.value?.batchId?.includes(value))

        }
        // return ( params.value.name.includes(value) )
      }

    },
    {
      field: "phone",
      headerName: "Phone",
      type: "string",
      width: 200,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "user",
      headerName: "Author",
      type: "object",
      width: 200,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar alt={params?.value?.name} src={params?.value?.profilePhoto} sx={{ width: 28, height: 28 }} />
          <Typography variant="subtitle2" noWrap>{params?.value?.name}</Typography>
        </Stack>
      ),
      pinned: 'left',

    },

    {
      field: "desc",
      headerName: "Description",
      type: "string",
      width: 350,
      align: "left",
      headerAlign: "left",
      pinned: 'left',
    },
    {
      field: "image",
      headerName: "Image",
      type: "object",
      width: 150,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => (
        params?.value ? (
          <img
            src={params.value}
            alt={`Image for row ${params.id}`}
            style={{ width: 150, height: 70, cursor: "pointer" }}
            onClick={() => handleOpen(params.value)}
          />
        ) : (
          <p>No Image</p>
        )
      ),
    },
    // {
    //   field: "image",
    //   headerName: "Image",
    //   type: "object",
    //   width: 150,
    //   align: "left",
    //   headerAlign: "left",
    //   renderCell: (params) => (
    //       params?.value != "" ? <img
    //         src={params.value}
    //         alt={`Image for row ${params.id}`}
    //         style={{ width: 150, height: 70 }}
    //       /> : <p>No Image</p>
    //     ),
    // },
    {
      field: "lecture",
      headerName: "Lecture",
      type: "string",
      width: 250,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "subject",
      headerName: "Subject",
      type: "string",
      width: 250,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "teacher",
      headerName: "Teacher",
      type: "string",
      width: 150,
      align: "left",
      headerAlign: "left",
    },

    {
      field: "isActive",
      headerName: "Status",
      type: "boolean",
      width: 100,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => (
        <div style={{ color: params.value == true ? 'green' : 'red' }}>
          {params.value ? 'Active' : 'In Active'}
        </div>
      ),
    },
    {
      field: "isResolved",
      headerName: "Resolve Status",
      type: "boolean",
      width: 150,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => (
        <div style={{ color: params.value == true ? 'green' : 'red' }}>
          {params.value ? 'Resolved' : 'Un Resolved'}
        </div>
      ),

    },
    {
      field: "createdAt",
      headerName: "Created At",
      type: "Date",
      width: 170,
      align: "left",
      headerAlign: "left",
      // editable: true,

    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const rowData = rows.find((item) => item.id === id);

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "primary.main"
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />
          ];
        }

        return [

          (((access?.accessForTab == 'readWrite') || access?.access.includes('all')) ?
            <Tooltip title={`${rowData?.isActive == true ? 'Make In Active' : 'Make Active'}`}>
              <GridActionsCellItem
                icon={rowData?.isActive == true ? <ToggleOnIcon style={{ color: 'green' }} /> : <ToggleOffIcon style={{ color: 'red' }} />}
                label="Change Status"
                onClick={() => makeActiveAndInActive(id)}
                color="inherit"
              />
            </Tooltip> : <></>),
          (((access?.accessForTab == 'readWrite') || access?.access.includes('all')) ?
            <Tooltip title={`${rowData?.isResolved == true ? 'Make Un Resolved' : 'Make Resolved'}`}>
              <GridActionsCellItem
                icon={rowData?.isResolved == true ? <ThumbUpAltIcon style={{ color: 'green' }} /> : <ThumbDownOffAltIcon style={{ color: 'red' }} />}
                label="Change Resolve Status"
                onClick={() => makeSolvedAndUnSolvedDoubt(id)}
                color="inherit"
              />
            </Tooltip> : <></>),
          ((access?.deleteAccess == true || access?.access.includes('all')) ?
            <Tooltip title={'Delete Doubt'}>
              <GridActionsCellItem
                icon={<DeleteIcon style={{ color: 'red' }} />}
                label="Delete Doubt"
                onClick={() => deleteDoubt(id)}
                color="inherit"
              />
            </Tooltip> : <></>),
          (((access?.accessForTab == 'read' || access?.accessForTab == 'readWrite') || access?.access.includes('all')) ?
            <Tooltip title={`Comments`}>
              <GridActionsCellItem
                icon={<CommentIcon style={{ color: 'blue' }} />}
                label="Comments"
                onClick={() => handleOpenCommentModal(id)}
                color="inherit"
              />
            </Tooltip> : <></>),
        ];
      }
    }
  ]



  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        "& .actions": {
          color: "text.secondary"
        },
        "& .textPrimary": {
          color: "text.primary"
        }
      }}
    >
      <Box sx={{ margin: '8px' }}>
        <h2>All Batch Doubt</h2>
      </Box>

      <Box m={2}>
        <input
          style={{
            width: 320,
            padding: "8px 12px",
            borderRadius: 6,
            border: "1px solid #ccc",
            outline: "none",
          }}
          placeholder="Search & press Enter"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setSearchText(inputText);
              setPaginationModel((p) => ({ ...p, page: 0 }));
            }
          }}
        />
      </Box>

      <DataGrid
        rows={rowsWithSerialNumber}
        columns={columns}
        autoHeight
        loading={loading}

        paginationMode="server"
        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[7, 25, 50]}

        filterMode="server"
        filterModel={filterModel}
        onFilterModelChange={(model) => {
          setFilterModel(model);
          const value = model.items?.[0]?.value || "";
          setPendingFilter(value);
        }}

        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}

        slots={{
          toolbar: (gridProps) => (
            <CustomToolbar {...gridProps} rows={rows} columns={columns} />
          ),
        }}
      />
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "55%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            textAlign: "center",
            maxWidth: "50%",
            maxHeight: "50%",
            overflow: "auto",
            position: "relative",
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "red",
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Large Image */}
          <img
            src={currentImage}
            alt="Large preview"
            style={{ maxWidth: "100%", maxHeight: "80%" }}
          />
        </Box>
      </Modal>
      {/* Comment Chat Modal */}
      <Modal open={commentModalOpen} onClose={handleCloseCommentModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            textAlign: "center",
            minWidth: 350,
            maxWidth: 500,
            maxHeight: 600,
            overflow: "auto",
            borderRadius: 2,
          }}
        >
          <IconButton
            onClick={handleCloseCommentModal}
            sx={{ position: "absolute", top: 8, right: 8, color: "red" }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h5" sx={{ mb: 2 }}>Doubt Comments</Typography>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            {rows.find(r => r.id === commentDoubtId)?.desc || 'No description available.'} - Raised By : {rows.find(r => r.id === commentDoubtId)?.user?.name || 'Unknown User'}
          </Typography>
          {/* <Typography variant="h6" sx={{ mb: 2 }}>Comments</Typography> */}
          {/* Status/Actions for this doubt */}
          {(() => {
            const doubt = rows.find(r => r.id === commentDoubtId);
            if (!doubt) return null;
            return (
              <Box sx={{ mb: 2, display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center', justifyContent: 'center' }}>
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => deleteDoubt(doubt.id)}
                >
                  Delete
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  color={doubt.isActive ? 'success' : 'error'}
                  startIcon={doubt.isActive ? <ToggleOnIcon /> : <ToggleOffIcon />}
                  onClick={() => makeActiveAndInActive(doubt.id)}
                >
                  {doubt.isActive ? 'Active' : 'Inactive'}
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  color={doubt.isResolved ? 'success' : 'error'}
                  startIcon={doubt.isResolved ? <ThumbUpAltIcon /> : <ThumbDownOffAltIcon />}
                  onClick={() => makeSolvedAndUnSolvedDoubt(doubt.id)}
                >
                  {doubt.isResolved ? 'Resolved' : 'Unresolved'}
                </Button>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 2 }}>
                  <Typography variant="caption">
                    Status: <span style={{ color: doubt.isActive ? 'green' : 'red' }}>{doubt.isActive ? 'Active' : 'Inactive'}</span>
                  </Typography>
                  <Typography variant="caption">
                    Resolve: <span style={{ color: doubt.isResolved ? 'green' : 'red' }}>{doubt.isResolved ? 'Resolved' : 'Unresolved'}</span>
                  </Typography>
                </Box>
              </Box>
            );
          })()}
          <Box sx={{ mb: 2, minHeight: 200, maxHeight: 250, overflowY: 'auto', background: '#f5f5f5', borderRadius: 1, p: 1 }}>
            {doubtComments.length === 0 ? (
              <Typography>No comments yet.</Typography>
            ) : (
              <List>
                {doubtComments.sort((a, b) => b.sno - a.sno).map((c) => (
                  <ListItem key={c.id} alignItems="flex-start" sx={{ justifyContent: c.isSender ? 'flex-end' : 'flex-start' }}>
                    <Box sx={{
                      bgcolor: c.isSender ? '#e3f2fd' : '#fffde7',
                      borderRadius: 2,
                      p: 1,
                      minWidth: 120,
                      maxWidth: 300,
                      display: 'inline-block',
                      position: 'relative',
                    }}>
                      <ListItemText
                        primary={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar src={c?.user?.image} alt={c?.user?.name} sx={{ width: 24, height: 24 }} />
                            <Typography>{c?.user?.name}</Typography>
                          </Box>
                        }
                        secondary={c.msg}
                        sx={{ textAlign: c.isSender ? 'right' : 'left' }}
                      />
                      <Box sx={{ display: 'flex', gap: 1, mt: 1, justifyContent: c.isSender ? 'flex-end' : 'flex-start' }}>
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          startIcon={<DeleteIcon />}
                          onClick={() => handleCommentDelete(c.id, commentDoubtId)}
                        >
                          Delete
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          color={c.isActive ? 'success' : 'error'}
                          startIcon={c.isActive ? <ToggleOnIcon /> : <ToggleOffIcon />}
                          onClick={() => {
                            handleActiveAndInActiveDoubtComment(c.id, commentDoubtId);
                          }}
                        >
                          {c.isActive ? 'Active' : 'Inactive'}
                        </Button>
                        {/* Resolved/Unresolved button removed as requested */}
                      </Box>
                    </Box>
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Type a message..."
              value={newComment}
              onChange={e => setNewComment(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter' && newComment.trim()) {
                  e.preventDefault(); // Prevent default behavior
                  handleSendComment(commentDoubtId);
                }
              }}
            />
            <Button variant="contained" onClick={() => handleSendComment(commentDoubtId)} disabled={!newComment.trim()}>
              Send
            </Button>
          </Box>
        </Box>
      </Modal>
      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Box>
  );
}
export default AllBatchDoubt
